import { createFileRoute } from '@tanstack/react-router';
import { PriceListForm } from '@/pages/price-lists/domains/price-list';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { WAREHOUSE_FILTER_TAB_VALUES } from '@/pages/warehouse/shared/warehouse-filter-tabs';
import { getWarehouseReturnUrl } from '@/pages/warehouse/shared/warehouse-sync-url';

const RETURN_URL = getWarehouseReturnUrl(
  WAREHOUSE_FILTER_TAB_VALUES.PRICE_LISTS
);

export const Route = createFileRoute(
  '/protected/_layout/price-lists/_layout/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewPriceListRoute,
});

function NewPriceListRoute() {
  return <PriceListForm returnUrl={RETURN_URL} />;
}
